export interface MenuCategory {
  id: string;
  name: string;
}

export interface MenuProduct {
  id: string;
  name: string;
  price: number;
  categoryId: string;
  image: string;
  quantity: number | null;
  available?: boolean;
}

export const mockCategories: MenuCategory[] = [
  { id: "burgers", name: "البرجر" },
  { id: "grills", name: "المشويات" },
  { id: "sides", name: "المقبلات" },
  { id: "drinks", name: "المشروبات" },
  { id: "desserts", name: "الحلويات" },
];

export const mockMenuProducts: MenuProduct[] = [
  {
    id: "p-burger-classic",
    name: "برجر كلاسيك",
    price: 18,
    categoryId: "burgers",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20classic%20beef%20burger%20with%20crisp%20lettuce%20tomato%20and%20melted%20cheddar%20on%20a%20toasted%20brioche%20bun%2C%20served%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-burger-classic&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-burger-double",
    name: "برجر دبل",
    price: 24,
    categoryId: "burgers",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20double%20patty%20smash%20burger%20with%20two%20beef%20patties%20melted%20american%20cheese%20and%20special%20sauce%20on%20a%20glazed%20bun%2C%20placed%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-burger-double&orientation=squarish",
    quantity: 3,
  },
  {
    id: "p-burger-chicken",
    name: "برجر دجاج مقرمش",
    price: 19,
    categoryId: "burgers",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20crispy%20fried%20chicken%20burger%20with%20golden%20breading%20lettuce%20and%20garlic%20mayo%20on%20a%20soft%20bun%2C%20served%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-burger-chicken&orientation=squarish",
    quantity: 0,
  },
  {
    id: "p-burger-cheese",
    name: "تشيز برجر",
    price: 21,
    categoryId: "burgers",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20cheeseburger%20with%20a%20thick%20juicy%20patty%20melted%20swiss%20cheese%20and%20caramelized%20onions%20on%20a%20toasted%20bun%2C%20placed%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-burger-cheese&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-shawarma",
    name: "شاورما دجاج",
    price: 16,
    categoryId: "grills",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20chicken%20shawarma%20wrap%20sliced%20in%20half%20showing%20tender%20marinated%20chicken%20pickles%20and%20garlic%20sauce%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-shawarma&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-kabsa",
    name: "كبسة دجاج",
    price: 22,
    categoryId: "grills",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20traditional%20saudi%20chicken%20kabsa%20with%20fragrant%20spiced%20rice%20roasted%20chicken%20leg%20and%20toasted%20almonds%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-kabsa&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-kebab",
    name: "كباب مشوي",
    price: 20,
    categoryId: "grills",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20grilled%20beef%20kebab%20skewers%20with%20charred%20edges%20onions%20and%20fresh%20parsley%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-kebab&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-smoked-burger",
    name: "برجر لحم مدخن",
    price: 26,
    categoryId: "grills",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20smoked%20brisket%20burger%20with%20tender%20pulled%20meat%20smoky%20bbq%20sauce%20and%20crispy%20onions%20on%20a%20toasted%20bun%2C%20placed%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-smoked-burger&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-fries",
    name: "بطاطس مقلية",
    price: 7,
    categoryId: "sides",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20golden%20crispy%20french%20fries%20in%20a%20small%20metal%20basket%20with%20a%20side%20of%20ketchup%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-fries&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-cheese-fries",
    name: "بطاطس بالجبنة",
    price: 11,
    categoryId: "sides",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20loaded%20cheese%20fries%20topped%20with%20melted%20cheddar%20sauce%20and%20green%20onions%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-cheese-fries&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-warak",
    name: "ورق عنب",
    price: 14,
    categoryId: "sides",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20stuffed%20grape%20leaves%20dolma%20arranged%20in%20a%20circle%20with%20lemon%20wedges%20and%20olive%20oil%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-warak&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-hummus",
    name: "حمص",
    price: 9,
    categoryId: "sides",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20creamy%20hummus%20with%20a%20well%20of%20olive%20oil%20paprika%20and%20fresh%20chickpeas%20served%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-hummus&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-soda",
    name: "مشروب غازي",
    price: 5,
    categoryId: "drinks",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20food%20photography%20of%20a%20glass%20of%20cola%20with%20ice%20cubes%20and%20bubbles%20on%20a%20warm%20beige%20ceramic%20coaster%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-soda&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-orange-juice",
    name: "عصير برتقال",
    price: 8,
    categoryId: "drinks",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20food%20photography%20of%20fresh%20orange%20juice%20in%20a%20tall%20glass%20with%20orange%20slices%20and%20a%20straw%20on%20a%20warm%20beige%20ceramic%20coaster%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-orange-juice&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-water",
    name: "ماء",
    price: 2,
    categoryId: "drinks",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20food%20photography%20of%20a%20clear%20glass%20bottle%20of%20mineral%20water%20with%20a%20small%20glass%20on%20a%20warm%20beige%20ceramic%20coaster%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-water&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-kunafa",
    name: "كنافة",
    price: 12,
    categoryId: "desserts",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20a%20slice%20of%20golden%20kunafa%20with%20melted%20cheese%20stretch%20and%20crushed%20pistachio%20drizzled%20with%20sugar%20syrup%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-kunafa&orientation=squarish",
    quantity: null,
  },
  {
    id: "p-baklava",
    name: "بقلاوة",
    price: 10,
    categoryId: "desserts",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20overhead%20food%20photography%20of%20layered%20pistachio%20baklava%20pieces%20with%20golden%20phyllo%20pastry%20and%20honey%20glaze%20on%20a%20warm%20beige%20ceramic%20plate%2C%20soft%20natural%20window%20light%2C%20minimal%20light%20beige%20background%2C%20editorial%20restaurant%20menu%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=400&height=400&seq=pos-baklava&orientation=squarish",
    quantity: null,
  },
];